export { AccessPage as default } from '@/components/enpages/Company/Access'
